import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../components/NavBar";
import Login from "../root/Login";
import {Button, Card, Popconfirm, Table, Tag} from "antd";
import Colors from "../../styles/Colors";
import {BiPencil, BiPlus, BiRefresh, BiTrash} from "react-icons/bi";
import Historials from "../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye} from "react-icons/bs";
import PlantillaModal from "../PlantillaModal";
import PlantillaLista from "../PlantillaLista";
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import {Dayjs} from 'dayjs';
import {GetComandesGeneradesIdPdf} from "../../dao/menudesign/comandes/GetComandesGeneradesIdPdf";
import toast, {Toaster} from "react-hot-toast";
import {QuestionCircleOutlined} from "@ant-design/icons";
import { GetPlats } from '../../dao/menudesign/GetPlats';
import { Plat } from '../../model/menudesign/Plat';
import { PlatIngredient } from '../../model/menudesign/PlatIngredient';
import { PlatVariacio } from '../../model/menudesign/PlatVariacio';
import Ingredient from '../../model/menudesign/Ingredient';
import { GetIngredients } from '../../dao/menudesign/GetIngredients';
import Ingredients from './Ingredients';
import IngredientModal from './components/IngredientModal';
import IngredientList from './components/IngredientList';
import PlatModal from './components/PlatModal';
import { GetPlatIngredients } from '../../dao/menudesign/GetPlatIngredients';
import PlatIngredientModal from './components/PlatIngredientModal';
import { GetPlatVariants } from '../../dao/menudesign/GetPlatVariants';
import PlatVariacioModal from './components/PlatVariacioModal';


const Plats = () => {
    const titol: string = "Plats";
    const nomPermis: string = "Plats";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<Plat[]>([]);
    const [coleccioPI, setDadesPI] = useState<PlatIngredient[]>([]);
    const [ingredientsList, setIngredients] = useState<Ingredient[]>([]);
    const [coleccioPV, setDadesPV] = useState<PlatVariacio[]>([]);
    const [elementSelected, setElementSelected] = useState<Plat>(new Plat());
    const [elementSelectedPI, setElementSelectedPI] = useState<PlatIngredient>(new PlatIngredient());
    const [elementSelectedI, setElementSelectedI] = useState<Ingredient>(new Ingredient());
    const [elementSelectedPV, setElementSelectedPV] = useState<PlatVariacio>(new PlatVariacio());
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [nouElementI, setNouElementI] = useState(false);
    const [nouElementPI, setNouElementPI] = useState(false);
    const [nouElementPV, setNouElementPV] = useState(false);
    const [editar, setEditar] = useState(false);
    const [visible, setVisible] = useState(true);
    const [visibleIng, setVisibleIng] = useState(true);
    const [visiblePI, setVisiblePI] = useState(true);
    const [visiblePV, setVisiblePV] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);

    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);
    const permisVisualitzacio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 0);

    const [filtres, setFiltres] = useState<RebutFIltre>(new RebutFIltre());

    const typeColors: { [key: string]: string } = {
        ou: 'magenta',
        pasta: 'lime',
        vegetal: 'orange',
        arrós: 'blue',
        cereal: 'cyan',
        especia: 'purple',
        condiment: 'gold',
        gra: 'volcano',
        verdura: 'green',
        tubercle: 'red',
        fruita: 'geekblue',
        lactic: 'cyan',
        peix: 'yellow',
        'carn vermella': 'pink',
        altres: 'default',
        hortalissa: 'brown',
        'carn blanca': 'white',
    };

    useEffect(() => {
        if (isLoggedIn) {
            handleLoadingChange(true)
            checkDades();
        }
    }, [id]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetPlats(page) || [];
        const platingredients = await GetPlatIngredients(page);
        const ingredients = await GetIngredients(page);
        const platvariants = await GetPlatVariants(page);
        setDades(dades);
        setDadesPI(platingredients);
        setIngredients(ingredients);
        setDadesPV(platvariants)
        await setNameFilters(dades);
        await setNameIFilters(ingredients);
        await setTipFiltres(ingredients);
        await handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }
    function toggleTablePI() {
        setVisiblePI(!visiblePI);
    }
    function toggleTableI() {
        setVisibleIng(!visibleIng);
    }

    function toggleTablePV() {
        setVisiblePI(!visiblePV);
    }

    async function deleteElement(id: number) {
        //await Deleteany(id, page);
        await checkDades();
    }
    async function deleteElementPI(id: number) {
        //await Deleteany(id, page);
        await checkDades();
    }

    async function deleteElementI(id: number) {
        //await Deleteany(id, page);
        await checkDades();
    }
    async function deleteElementPV(id: number) {
        //await Deleteany(id, page);
        await checkDades();
    }

    function afegirElement(element: Plat) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }
    function afegirElementPI(element: PlatIngredient) {
        setNouElementPI(!nouElementPI);
        setElementSelectedPI(element);
    }
    function afegirElementI(element: Ingredient) {
        setNouElementI(!nouElementI);
        setElementSelectedI(element);
    }
    function afegirElementPV(element: PlatVariacio) {
        setNouElementPV(!nouElementPV);
        setElementSelectedPV(element);
    }

    function togleNouElement(element: Plat, edit: boolean) {
        setNouElement(!nouElement);
        setEditar(edit);
        setElementSelected(element);
    }
    function togleNouElementPI(element: PlatIngredient, edit: boolean) {
        setNouElementPI(!nouElementPI);
        setEditar(edit);
        setElementSelectedPI(element);
    }
    function togleNouElementI(element: Ingredient) {
        setNouElementI(!nouElementI);
        setElementSelectedI(element);
    }
    function togleNouElementPV(element: PlatVariacio, edit: boolean) {
        setNouElementPV(!nouElementPV);
        setEditar(edit);
        setElementSelectedPV(element);
    }

    function handleCloseModal() {
        setNouElement(false);
        checkDades();
    }
    function handleCloseModalPI() {
        setNouElementPI(false);
        checkDades();
    }
    function handleCloseModalI() {
        setNouElementI(false);
        checkDades();
    }
    function handleCloseModalPV() {
        setNouElementPV(false);
        checkDades();
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: Plat[]) {
        const anyNames = elements.map((element) => ({
            text: element.nom,
            value: element.nom,
        }));
        setNomFiltres(anyNames);
    }
    function setNameIFilters(ingredients: Ingredient[]) {
        if (ingredients && ingredients.length > 0) {
            const ingredientNames = ingredients.map((ingredient) => ({
                text: ingredient.nom,
                value: ingredient.nom,
            }));
            setNomFiltres(ingredientNames);
        }
    }

    function setTipFiltres(ingredients: Ingredient[]) {
        if (ingredients && ingredients.length > 0) {
            const uniqueNames = new Set<string>();
            ingredients.forEach((ingredient) => uniqueNames.add(ingredient.tipus));

            const ingredientNames = Array.from(uniqueNames).map((name) => ({
                text: name,
                value: name,
            }));

            setTipusFiltres(ingredientNames);
        }
    }
    /**
     * FILTRES
     **/

    const handleNumberInput = (newIdRebut: number | null, attributeName: string) => {
        const idRebut = newIdRebut || 0;
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: idRebut,
        }));
    };

    const handleStringInput = (event: React.ChangeEvent<HTMLInputElement>, attributeName: string) => {
        const value = event.target.value || "";  // Usar una cadena vacía si el valor es nulo
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: value,
        }));
    };


    const handleDateInput = (value: Dayjs | null, attributeName: string, format: string) => {
        const date = value && value.format(format) || "";

        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: date,
        }));
    };


    /**
     * --- FILTRES ----
     **/

    const columns: ColumnsType<Plat> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 10,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'ingredients',
            title: 'Ingredients',
            dataIndex: 'ingredients',
            render: (platingredients: Array<PlatIngredient>) => (
            <>
                {platingredients.map((pi) => {
                const ingredient = ingredientsList.find(i => i.id == pi.id_ingredient);
                if(!ingredient){
                    return null;
                }
                return (
                    <Tag color={Colors.colors.color3} key={pi.id_ingredient}>
                    {ingredient.nom}
                    </Tag>
                );
                })}
            </>
            ),
            width: 15,
        },
        {
            key: 'variacions',
            title: 'Variants',
            dataIndex: 'variacions',
            render: (variacions: Array<PlatVariacio>) => (
                <>
                    {variacions.map((variant) => {
                        const alternativa = coleccio.find(p => p.id == variant.id_alternativa);
                        if(!alternativa){
                            return null;
                        }
                        return (
                            <Tag color={Colors.colors.color3} key={variant.id_alternativa}>
                            {alternativa.nom}
                            </Tag>
                        );
                    })}
                </>
                
            ) ,
            width: 15,
        },
        {
            key: 'cost',
            title: 'Cost',
            dataIndex: 'cost',
            render: (cost: number) => cost.toFixed(2) +'€',
            width: 10,
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    {permisosEdicio && (
                        <>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => togleNouElement(ele, true)}><BiPencil/></Button>
                            {" "}     
                            <Popconfirm
                                title="Eliminant"
                                description="Vols eliminar definitivament aquest element?"
                                onConfirm={() => deleteElement(ele.id)}
                                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            >
                                <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                            </Popconfirm>
                            {" "}
                        </>
                    )}
                    <Button title={"Mostrar"} onClick={() => togleNouElement(ele, false)}
                            style={{backgroundColor: Colors.colors.color4}}><BsEye/></Button>
                </>
            ),
        },
    ];
    const columnsPI: ColumnsType<PlatIngredient> = [
        {
            key: 'id_plat',
            title: 'ID Plat',
            dataIndex: 'id_plat',
            width: 10,
            responsive: ['lg'],
            sorter: (a, b) => a.id_plat - b.id_plat,
        },
        {
            key: 'id_ingredient',
            title: 'ID Ingredient',
            dataIndex: 'id_ingredient',
            width: 10,
        },
        {
            key: 'qinfantil',
            title: 'Quant Inf',
            dataIndex: 'qinfantil',
            render: (qInfantil: number) => qInfantil.toFixed(2),
            width: 10,
        },
        {
            key: 'qprimaria',
            title: 'Quant Prim',
            dataIndex: 'qprimaria',
            render: (qPrimaria: number) => qPrimaria.toFixed(2),
            width: 10,
        },
        {
            key: 'qadult',
            title: 'Quant Adult',
            dataIndex: 'qadult',
            render: (qAdult: number) => qAdult.toFixed(2),
            width: 10,
        },
        {
            key: 'per100',
            title: 'Per 100',
            dataIndex: 'per100',
            render: (per100: number) => per100.toFixed(1),
            width: 10,
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, pi) => (
                <>
                    {permisosEdicio && (
                        <>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => togleNouElementPI(pi, true)}><BiPencil/></Button>
                            {" "}        
                            <Popconfirm
                                title="Eliminant"
                                description="Vols eliminar definitivament aquest element?"
                                onConfirm={() => deleteElementPI(pi.id_plat)}
                                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            >
                                <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                            </Popconfirm>
                            {" "}
                        </>
                    )}
                    <Button title={"Mostrar"} onClick={() => togleNouElementPI(pi, false)}
                            style={{backgroundColor: Colors.colors.color4}}><BsEye/></Button>
                </>
            ),
        },
    ];
    const columnsPV: ColumnsType<PlatVariacio> = [
        {
            key: 'id_plat',
            title: 'ID Plat',
            dataIndex: 'id_plat',
            width: 10,
            responsive: ['lg'],
            sorter: (a, b) => a.id_plat - b.id_plat,
        },
        {
            key: 'id_variacio',
            title: 'ID Variant',
            dataIndex: 'id_variacio',
            width: 10,
            responsive: ['lg'],
            sorter: (a, b) => a.id_variacio - b.id_variacio,
        },
        {
            key: 'id_alternativa',
            title: 'ID Plat alternatiu',
            dataIndex: 'id_alternativa',
            width: 10,
            responsive: ['lg'],
            sorter: (a, b) => a.id_alternativa - b.id_alternativa,
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, pv) => (
                <>
                    {permisosEdicio && (
                        <>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => togleNouElementPV(pv, true)}><BiPencil/></Button>
                            {" "}        
                            <Popconfirm
                                title="Eliminant"
                                description="Vols eliminar definitivament aquest element?"
                                onConfirm={() => deleteElementPV(pv.id_plat)}
                                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            >
                                <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                            </Popconfirm>
                            {" "}
                        </>
                    )}
                    <Button title={"Mostrar"} onClick={() => togleNouElementPV(pv, false)}
                            style={{backgroundColor: Colors.colors.color4}}><BsEye/></Button>
                </>
            ),
        },
    ];
    const columnsI: ColumnsType<Ingredient> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
            filterSearch: true,
            onFilter: (value, record) => (typeof value === 'string' ? record.id.toString().startsWith(value) : false),
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'tipus',
            title: 'Tipus',
            dataIndex: 'tipus',
            width: 30,
            filterSearch: true,
            filters: tipusFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.tipus.startsWith(value) : false),
            render: (name: string) => (
                <Tag color={typeColors[name]}>
                    {name}
                </Tag>
            ),
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ing) => (
                <>
                    <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => togleNouElementI(ing)}><BiPencil/></Button>
                    {" "}
                    <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}
                            onClick={() => deleteElementI(ing.id)}><BiTrash/></Button>
                    {" "}
                    <Button title={"Veure Ingredients"} style={{backgroundColor: Colors.colors.color4}}><BsEye/></Button>
                </>
            ),
        },
    ];
    const tableProps: TableProps<Plat> = {
        loading
    };
    const tablePropsPI: TableProps<PlatIngredient> = {
        loading
    };
    const tablePropsI: TableProps<Ingredient> = {
        loading
    };
    const tablePropsPV: TableProps<PlatVariacio> = {
        loading
    };

    function modificarDatosForm() {
        //form.setFieldsValue({ remesa: 0 });
    }

    const onChange: TableProps<Plat>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRender2 = (ele: Plat) => {
        return (
            <PlantillaLista element={ele}/>
        );
    };

    const onChangePI: TableProps<PlatIngredient>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const onChangePV: TableProps<PlatVariacio>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };
    
    const onChangeI: TableProps<Ingredient>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRenderI2 = (ele: Ingredient) => {
        return (
            <IngredientList ingredient={ele}/>
        );
    };

    async function handleDownload (id: string)  {
        setLoading(true);
        //const documentUrl = await GetComandesGeneradesIdPdf(page, id);
        const documentUrl = ""; //TODO: delete

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `facturaRemesa${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(true);
    };

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            {permisosEdicio &&
                                <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    afegirElement(new Plat())}><BiPlus/></Button>
                            }
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                rowKey="id"
                                columns={columns}
                                expandable={{
                                    expandedRowRender: (record) =>
                                        expandedRowRender2(record),
                                    rowExpandable: (record) => true,

                                }}
                                dataSource={coleccio}
                            />
                        )}
                    </Card>
                    <br/>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            {permisosEdicio &&
                                <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    afegirElementPI(new PlatIngredient())}><BiPlus/></Button>
                            }
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTablePI}>Ingredients dels Plats</h4>
                        {visiblePI && (
                            <Table
                                {...tablePropsPI}
                                onChange={onChangePI}
                                columns={columnsPI}
                                dataSource={coleccioPI}
                            />
                        )}
                    </Card>
                    <br/>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            {permisosEdicio &&
                                <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    afegirElementPV(new PlatVariacio())}><BiPlus/></Button>
                            }
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTablePV}>Variants dels Plats</h4>
                        {visiblePV && (
                            <Table
                                {...tablePropsPV}
                                onChange={onChangePV}
                                columns={columnsPV}
                                dataSource={coleccioPV}
                            />
                        )}
                    </Card>
                    <br/>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            {permisosEdicio &&
                                <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    afegirElementI(new Ingredient())}><BiPlus/></Button>
                            }
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTableI}>Ingredients</h4>
                        {visibleIng && (
                            <Table
                                {...tablePropsI}
                                onChange={onChangeI}
                                columns={columnsI}
                                expandable={{
                                    expandedRowRender: (record) =>
                                        expandedRowRenderI2(record),
                                    rowExpandable: (record) => true,

                                }}
                                dataSource={ingredientsList}
                            />
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={titol} pagina={page}/>
                    {nouElement && (
                        <PlatModal element={elementSelected} onClose={handleCloseModal} visible={nouElement} editar={editar} page={page}/>
                    )}
                    {nouElementPI && (
                        <PlatIngredientModal element={elementSelectedPI} onClose={handleCloseModalPI} visible={nouElementPI} editar={editar} page={page}/>
                    )}
                    {nouElementPV && (
                        <PlatVariacioModal element={elementSelectedPV} onClose={handleCloseModalPV} visible={nouElementPV} editar={editar} page={page}/>
                    )}
                    {nouElementI && (
                        <IngredientModal ingredient={elementSelectedI} onClose={handleCloseModalI} visible={nouElementI} page={page}/>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default Plats;
